import Styled from 'styled-components'

export const Description = Styled.span`
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  line-height: 24px;
  color: #6F767E;
`
